<template>
    <el-popover
      placement="top"
      :title="filters[filterKey].title"
      :popper-class="'popover-style'"
      trigger="click"
      :visible="filters[filterKey].isFilter"
    >
      <template #reference>
        <el-button class="m-2" link @click="toggleFilter">
          <!-- <font-awesome-icon icon="fa-solid fa-filter" /> -->
           <img src="../assets/sort.png" alt="" srcset="" width="14px">
        </el-button>
      </template>
  
      <template #default>
        <!-- Additional content passed into the default slot -->
        <slot></slot>
        <div class="mt-2">
          <!-- Default buttons -->
          <el-button type="primary" @click="applyFilter">Apply</el-button>
          <el-button type="link" @click="onPopoverCancled">Cancel</el-button>
        </div>
        
      </template>
    </el-popover>
  </template>
  
<style lang="scss">
    .popover-style{
        width: unset !important;
        min-width: 200px !important;
    }
</style>
  <script setup>
  import { ref, defineProps, defineEmits, watch } from 'vue';
  
  // Define props
  const props = defineProps({
    filterKey: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  });
  
  // Define emits to communicate with the parent component if needed
  const emit = defineEmits();
  
  // Reactive variables from the props
  const filterKey = props.filterKey;
  const filters = props.filters;
  
  // Toggle the filter visibility
    const toggleFilter = () => {
    // Before toggling, emit an event to close other popovers
    emit('toggle-popover', filterKey);
    filters[filterKey].isFilter = !filters[filterKey].isFilter;
    };
  
  // Apply the filter (you can extend this with custom logic)
  const applyFilter = () => {
        console.log(`${filterKey} filter applied with value: `, filters[filterKey].value);
        // You can trigger a custom event to notify the parent or do further logic
        emit('apply-filter', filterKey, filters[filterKey]);
        filters[filterKey].isFilter = !filters[filterKey].isFilter;
  };
  
  const onPopoverCancled = () => {
    emit('cancle-popover', filterKey);
    filters[filterKey].isFilter = !filters[filterKey].isFilter;
  };
  </script>
  